@if (unconfigured()) {
<p class="dashboard-filter__message">{{ 'Dashboard.FilterUnconfigured' | translate }}</p>
} @else {
<div class="dashboard-filter__controls">
    @for (field of fields(); track field.view.id) { @if (field.view.multiple) {
    <pulse-multiselect
        class="dashboard-filter__control"
        applyOnClose
        [values]="field.view.selected"
        [searchable]="field.view.search"
        [searchText]="field.search"
        [clearable]="field.view.clearable"
        [clearLabel]="field.view.clearLabel"
        [placeholder]="field.view.placeholder"
        [selectedText]="field.view.selectedText"
        [ariaLabel]="field.view.label"
        (valuesChange)="onSelected(field.view, $event)"
        (searchTextChange)="onSearch(field.view, $event)"
    >
        <div pulsePopupOptions multi>
            @for (option of field.options; track option.value) {
            <div ngOption [value]="option.value" [label]="option.label">{{ option.label }}</div>
            }
        </div>
        @if (field.status !== '') {
        <p class="dashboard-filter__status">{{ field.status | translate }}</p>
        }
    </pulse-multiselect>
    } @else {
    <pulse-combobox
        class="dashboard-filter__control"
        [value]="field.view.selected[0] ?? null"
        [searchable]="field.view.search"
        [searchText]="field.search"
        [clearable]="field.view.clearable"
        [clearLabel]="field.view.clearLabel"
        [placeholder]="field.view.placeholder"
        [ariaLabel]="field.view.label"
        (valueChange)="onPicked(field.view, $event)"
        (searchTextChange)="onSearch(field.view, $event)"
    >
        <div pulsePopupOptions>
            @for (option of field.options; track option.value) {
            <div ngOption [value]="option.value" [label]="option.label">
                <pulse-combobox-match [text]="option.label" [query]="field.search" />
            </div>
            }
        </div>
        @if (field.status !== '') {
        <p class="dashboard-filter__status">{{ field.status | translate }}</p>
        }
    </pulse-combobox>
    } }
</div>

@if (showAppliedRow()) {
<div class="dashboard-filter__applied">
    @if (showChips()) {
    <pulse-filter-chips
        [chips]="chips()"
        [label]="'Dashboard.FilterAppliedLabel' | translate"
        [removable]="true"
        (removed)="removeChip($event)"
    />
    } @if (showClearAll()) {
    <button type="button" class="dashboard-filter__clear-all" (click)="clearAll()">
        {{ 'Dashboard.FilterClearAll' | translate }}
    </button>
    }
</div>
} }
